import { KeyedObject, TypedObject } from "@sanity/types";
import styles from "./Table.module.css";
import classNames from "classnames";

//#region [Props]
type TableProps = {
    value: TableObj;
    className?: string;
}

type TableObj = {
    rows: TableRowObj[];
} & KeyedObject & TypedObject;

type TableRowObj = {
    cells: string[];
} & KeyedObject & TypedObject;

//#endregion

//#region [Component]
export default function Table(props: TableProps) {
    if ((props.value?.rows?.length ?? 0) === 0) {
        return null;
    }

    return (<table className={classNames(styles.table, props.className)}>
        <tbody>
            {props.value.rows.map((row) => (<tr key={row._key}>
                {row.cells.map((cell, cellIndex) => <td key={`${row._key}${cellIndex}`} className={styles.td}>{cell ? cell : '\u00A0'}</td>)}
            </tr>))}
        </tbody>
    </table>);

}
//#endregion